import './style.scss';
import psl_actions from '../../libs/psl_actions.js';
import psl_ui from '../../libs/psl_ui.js';
import template from './template.pst';

import {wait} from '../../libs/psl_polyfills.js';

import CONFIG from '../../CONFIG.js';

psl_ui.templates.add('popup_viewer',template);

psl_actions.add('popup_viewer.prev',e=>{
	const popup=psl_ui.DOM.controller(e.target);
	if(!popup || (popup.constructor!==PopupViewer)) return;

	let prev=popup.current-1;
	if(prev<0) prev+=popup.data.list.length;

	popup.toggle(prev);
});

psl_actions.add('popup_viewer.next',e=>{
	const popup=psl_ui.DOM.controller(e.target);
	if(!popup || (popup.constructor!==PopupViewer)) return;

	let next=popup.current+1;
	if(next>=popup.data.list.length) next-=popup.data.list.length;

	popup.toggle(next);
});

psl_actions.add('popup_viewer.play',e=>{
	const popup=psl_ui.DOM.controller(e.target);
	if(!popup || (popup.constructor!==PopupViewer)) return;

	popup.play();

});

const arr=['name','sub','desc','']

class PopupViewer{
	constructor(){
		const {el, rpoints} = psl_ui.templates.render('popup_viewer');

		this._rpoints=rpoints;
		this.view=el;
		this.view.controller=this;


		this._state={}
		this._state.progress_dragging=false;

		this.view.addEventListener('touchstart',({touches,target})=>{
			this._state.start_x=touches[0].clientX;
			this._state.start_y=touches[0].clientY;
			this._state.touch_started_on_progress=target.closest('.progress_bar')!==null;
		});

		this.view.addEventListener('touchend',({changedTouches})=>{
			if(this._state.progress_dragging || this._state.touch_started_on_progress) return;
			const dx = changedTouches[0].clientX - this._state.start_x;
			const dy = changedTouches[0].clientY - this._state.start_y;
			if (Math.abs(dx) > 1920*0.05) {
				if (Math.abs(dy / dx) <= Math.tan(45 * 1.5 / 180 * Math.PI)) {
					if (dx < 0) {
						let next=this.current+1;
						if(next>=this.data.list.length) next-=this.data.list.length;
						this.toggle(next);
					} else {
						let prev=this.current-1;
						if(prev<0) prev+=this.data.list.length;
						this.toggle(prev);
					}
				}
			}
		});

		this._setup_progress_bar_handlers();
	}

	async render(data,current=0){
		this.data=data;
		this._rpoints.back_label.innerHTML=data.back_label||"";
		this._rpoints.arrows.classList[this.data.list.length>1?'remove':'add']('hidden');
		await this.toggle(current,true);
	}

	async _render_current(force){
		let data=this.data.list[this.current];

		if(!force){
			this._rpoints.content.classList.add('hidden');
			this._rpoints.progress_bar.classList.add('hidden');
			await wait(250);
		}

		this._rpoints.name.innerHTML=data.name||"";
		this._rpoints.sub.innerHTML=data.sub||"";
		this._rpoints.desc.innerHTML=data.desc||"";

		if(data.video){
			this._rpoints.content.innerHTML=`<video>
				<source src="${CONFIG.backend_base_url}files/${data.video}" type="video/mp4">
			</video>`;
			const video=this._rpoints.content.firstChild;
			this._rpoints.duration.style.width=0;
			this._rpoints.indicator.style.left='0%';
			video.addEventListener('timeupdate',(e)=>{
				const video=e.target;
				if(!this._state.progress_dragging){
					const percent=100*video.currentTime/video.duration;
					this._rpoints.duration.style.width=`${percent}%`;
					this._rpoints.indicator.style.left=`${percent}%`;
				}
			});
			video.addEventListener('ended',(e)=>{
				this._rpoints.btn_play.className='icon play';
			});
			this._rpoints.zoom.classList.add('hidden');
			this._rpoints.btn_play.className='icon play';
			this._rpoints.progress_bar.classList.remove('hidden');
		} else {
			this._rpoints.content.innerHTML=`<img src="${CONFIG.backend_base_url}files/${data.img}">`;
			if(data.map){
				this._rpoints.content.dataset.action="maps.show";
				this._rpoints.content.dataset.data=data.map;
			} else {
				delete this._rpoints.content.dataset.action;
				delete this._rpoints.content.dataset.data;
			}
			this._rpoints.progress_bar.classList.add('hidden');
			this._rpoints.zoom.classList.add('hidden');
			this._rpoints.btn_play.classList.add('hidden');
		}

		if(!force){
			this._rpoints.content.classList.remove('hidden');
			await wait(250);
		}
	}

	async toggle(i,force=false){
		this.current=i;
		this._render_current(force);
	}

	_setup_progress_bar_handlers(){
		const stop_dragging=()=>{
			this._state.progress_dragging=false;
		};

		this._rpoints.progress_bar.addEventListener('mousedown',(e)=>{
			e.preventDefault();
			const video=this.view.querySelector('video');
			if(!video) return;
			this._state.progress_dragging=true;
			this._seek_to_position(e,video);
		});

		this.view.addEventListener('mousemove',(e)=>{
			if(this._state.progress_dragging){
				e.preventDefault();
				const video=this.view.querySelector('video');
				if(!video) return;
				this._seek_to_position(e,video);
			}
		});

		this.view.addEventListener('mouseup',stop_dragging);
		this.view.addEventListener('mouseleave',stop_dragging);

		this._rpoints.progress_bar.addEventListener('touchstart',(e)=>{
			const video=this.view.querySelector('video');
			if(!video) return;
			this._state.progress_dragging=true;
			this._seek_to_position(e.touches[0],video);
		});

		this.view.addEventListener('touchmove',(e)=>{
			if(this._state.progress_dragging){
				e.preventDefault();
				const video=this.view.querySelector('video');
				if(!video) return;
				this._seek_to_position(e.touches[0],video);
			}
		});

		this.view.addEventListener('touchend',stop_dragging);
		this.view.addEventListener('touchcancel',stop_dragging);
	}

	_seek_to_position(e,video){
		if(!video.duration || isNaN(video.duration)) return;
		const rect=this._rpoints.progress_bar.getBoundingClientRect();
		const x=e.clientX-rect.left;
		const percent=Math.max(0,Math.min(100,(x/rect.width)*100));
		const time=(percent/100)*video.duration;
		video.currentTime=time;
		this._rpoints.duration.style.width=`${percent}%`;
		this._rpoints.indicator.style.left=`${percent}%`;
	}

	play(){
		const video=this.view.querySelector('video');
		if(!video) return;

		video[video.paused?'play':'pause']();

		this._rpoints.btn_play.className=`icon ${video.paused?'play':'pause'}`;
	}
}

export default PopupViewer;
